import MasterCrud from "@/components/app/MasterCrud";
export default function OverheadCats() {
  return (
    <MasterCrud endpoint="/overhead-categories" title="Kategori Overhead"
      fields={[
        { key: "code", label: "Kode", type: "text", required: true },
        { key: "name", label: "Nama Kategori", type: "text", required: true },
        { key: "is_variable", label: "Variabel", type: "checkbox", default: true, hint: "Jika tetap, nonaktifkan" },
        { key: "allocation_basis", label: "Dasar Alokasi", type: "select", options: [
          { value: "unit", label: "Per Unit Produk" },
          { value: "machine_hour", label: "Jam Mesin" },
          { value: "labor_hour", label: "Jam Kerja" },
          { value: "material_cost", label: "Biaya Bahan" },
        ], default: "unit" },
        { key: "description", label: "Deskripsi", type: "textarea" },
      ]}
    />
  );
}
